import { add, formatISO } from 'date-fns';

export const reformatDateUtils = (date: Date): string => {
  return formatISO(date, { representation: 'date' });
};

export const reformatDateWithTimeUtils = (date: Date): string => {
  // crop from 2023-02-06T11:51:43.666Z to 2023-02-06T11:51
  return formatISO(date).slice(0, 16);
};

export const reformatNumberWithLocale = (value: string | number, numberFormatString: string): string => {
  const [thousandSeparator, decimalSeparator] = numberFormatString.split('_');

  return Number(value)
    .toFixed(2)
    .replace('.', decimalSeparator)
    .replace(/\d(?=(\d{3})+\.)/g, '$&' + thousandSeparator);
};

export const addDaysForDate = (date: Date, amountDays: number): string => {
  const newDate = add(date, { days: amountDays });
  return reformatDateUtils(newDate);
};
